import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
import Footer from "../Components/common/footer";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";

function NotesSectionPage() {
  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);
  const dispatch = useDispatch();
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 22).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  useEffect(() => {
    fetchShakespeareStatus(getCaseId(), 22, dispatch);
  }, [dispatch]);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container">
          <NavBar flaggedPageName="22" />

          <div className="main-content p-t-130">
            <NotesSectionDashboard pageName={"Notes"} pageObj={pageObject} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default NotesSectionPage;
